import React from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  Flex,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";

import {
  UPSERT_CERTIFICATION_MUTATION
} from "../graphql/admin";

import MoblyzeApolloClient from "../services/MoblyzeApolloClient";

import {
  BasicInput,
  SectionTitle,
} from "./HookFormsInputs";

export default function AddCertificationModal({
  createdCallback,
  isOpen,
  onClose,
  certification,
}) {
  const isCreate = !certification?.id || certification.id === "new";

  const toast = useToast();

  const {
    handleSubmit: handleSubmitModal,
    register: registerModal,
    control: controlModal,
    formState: { errors: errorsModal, isSubmitting: isSubmittingModal },
    reset,
  } = useForm({
    defaultValues: {
      name: certification?.name || "",
    },
  });

  async function onSubmit(values) {
    const variables = {
      ...values,
    };
    if (!isCreate) {
      // If editing an existing certification, we need to pass the id
      variables.id = certification.id;
    }

    try {
      const response = await MoblyzeApolloClient.mutate({
        mutation: UPSERT_CERTIFICATION_MUTATION,
        variables,
      });
      console.log("Response from upsert:", response);
      if (response?.data?.upsertCertification) {
        // If we successfully created or updated the certification, navigate back to the certifications page
        if (createdCallback) {
          createdCallback(response.data.upsertCertification);
        }
        toast({
          title: "Certification added",
          description: "The certification has been successfully added.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        reset({
          name: "",
        });
        onClose();
      } else {
        console.error("Failed to upsert certification:", response);
        toast({
          title: "Error",
          description: "Failed to add certification",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error during upsert:", error);
      toast({
        title: "Error",
        description: "An error occurred while adding the certification",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} variant={"darkMode"}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <ModalCloseButton />
        </ModalHeader>

        <ModalBody pb="4">
          <Flex direction="column">
            <form
              onSubmit={(event) => {
                event.stopPropagation();
                event.preventDefault();
                handleSubmitModal(onSubmit)(event);
              }}
            >
              <SectionTitle title="Add Certification" />

              <BasicInput
                label="Name"
                name="name"
                placeholder="Name of the certification"
                register={registerModal}
                control={controlModal}
                errors={errorsModal}
                required
              />

              <Button mt={4} isLoading={isSubmittingModal} type="submit">
                Save
              </Button>
            </form>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
